import { Navigate, useLocation } from 'react-router-dom';

/**
 * Redirect de compatibilidad para URLs viejas tras el rename de canales
 * (WhatsApp → Chats, Call Center → Llamadas).
 *
 * Reescribe SOLO el prefijo del módulo en el pathname absoluto y preserva todo lo
 * demás (segmentos hijos, :params, query string y hash). Así una sola ruta comodín
 * cubre todas las sub-rutas viejas del módulo, sin enumerarlas una por una.
 *
 *   /store/mi-tienda/whatsapp/inbox/abc?x=1  →  /store/mi-tienda/chats/inbox/abc?x=1
 *
 * El `replace` evita ensuciar el historial del navegador (el usuario no debería
 * poder "volver" a una URL muerta).
 */
export function LegacyRouteRedirect({ from, to }: { from: string; to: string }) {
  const { pathname, search, hash } = useLocation();
  // replace() sin regex global: sustituye solo la PRIMERA coincidencia, que es el
  // segmento del módulo (el slug de la tienda nunca contiene estos prefijos).
  const next = pathname.replace(from, to);
  return <Navigate to={`${next}${search}${hash}`} replace />;
}
